module.exports = __webpack_public_path__ + "static/media/clock.34658961.svg";